import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import html2pdf from "html2pdf.js";
import { Download, FileDown, Printer } from "lucide-react";
import Loading from "./Loading";

export default function Recibo() {
  const { id } = useParams();
  const reciboref = useRef();
  const [recibo, setRecibo] = useState({});
  const [dataTransacao, setDataTranscao] = useState("");
  const [dataDownload, setDataDownload] = useState("");
  const [loading, setLoading] = useState(false);

  async function inserirDataDownloar() {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const data = gerarDataAtual();
      console.log(data);
      const dataDownload = await axios.put(
        `https://api-eyazs-production-8f74.up.railway.app/recibo/${id}`,
        {
          dataDownload: data,
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
            'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
          }
        }
      );
      if (dataDownload) {
        console("Data Adicionada com Sucesso!");
      }
    } catch (erro) {
      console.log(erro);
    }
  }

  const gerarDataAtual = () => {
    const dataAtual = new Date();

    const ano = dataAtual.getFullYear();
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");
    const dia = String(dataAtual.getDate()).padStart(2, "0");

    const horas = String(dataAtual.getHours()).padStart(2, "0");
    const minutos = String(dataAtual.getMinutes()).padStart(2, "0");
    const segundos = String(dataAtual.getSeconds()).padStart(2, "0");

    const dataFormatada = `${dia}-${mes}-${ano} ${horas}:${minutos}:${segundos}`;

    return dataFormatada;
  };

  function baixarRecibo() {
    const elemento = reciboref.current;
    const option = {
      margin: 0,
      filename: "recibo.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };    
    html2pdf().set(option).from(elemento).save();
  }

  async function mostrarRecibo() {
    try {
      setLoading(true)
      const token = JSON.parse(localStorage.getItem("token"));
      const dadosRecibo = await axios.get(
        `https://api-eyazs-production-8f74.up.railway.app/recibo/${id}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
            'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
          }
        }
      );
      if (dadosRecibo) {
        setRecibo(dadosRecibo.data);
        const dataTransacao = new Date(dadosRecibo.data.dataTransacao);
        const dia = String(dataTransacao.getDate()).padStart(2, "0");
        const mes = String(dataTransacao.getMonth() + 1).padStart(2, "0");
        const ano = dataTransacao.getFullYear();
        const dataFormatada = `${dia}/${mes}/${ano}`;
        setDataTranscao(dataFormatada);
      }
    } catch (erro) {
      console.log(erro);
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    mostrarRecibo();
  }, []);

  return (
    <div>
      {
        loading ?
        <div>
          <Loading/>
        </div>:
        <div className=" flex justify-center font-questrial flex-col bg-gray-400 w-full min-h-screen p-4">
        <div
          className=" bg-white p-4 md:p-8 w-full max-w-4xl shadow-md rounded-lg"
          ref={reciboref}
        >
          <div className="border border-black p-4 md:p-6">
            <div className="border border-black flex flex-col md:flex-row justify-between items-center py pr-4 mt-1 h-auto md:h-[110px] font-medium">
              <div className="flex justify-center md:justify-start mb-4 md:mb-0">
                <img
                  className="max-w-[80px] md:max-w-[150px]"
                  src="../../images/logo.png"
                  alt="Logo"
                />
              </div>
              <div className="flex flex-col text-center md:text-right">
                <h1 className="text-lg">Eyazs Imperium</h1>
                <span className="text-xs md:text-sm">8º Bairro Macurungo, rua 33 Beira-Mozambique</span>
                <span className="text-xs md:text-sm">
                  Contacto: Cell: +258 86 601 2012/ +258 87 89 68 000 Email: comercial@eyazs.com
                </span>
              </div>
            </div>
            <div className="flex flex-col items-center font-semibold mt-4">
              <div className="flex flex-col text-center">
                <span className="text-xs md:text-sm">NUIT: 400830053</span>
                <span className="text-xs md:text-sm">DELEGACAO DA BEIRA</span>
              </div>
            </div>
            <div className="flex justify-between font-medium mt-4">
              <span className="text-sm font-bold">COMPROVATIVO DE PAGAMENTO</span>
              <span className="text-sm">Recibo Nº: {recibo.idRecibo}</span>
            </div>
            <div className="mt-4 font-medium text-sm">Dados da Transacao</div>
            <div className="border-t border-black my-2"></div>
            <div className="w-full overflow-x-auto">
              <table className="w-full mt-2 mb-4 text-xs md:text-sm">
                <thead>
                  <tr className="boreder">
                    <th className=" pb-4 border font-medium text-center">Cliente</th>
                    <th className=" pb-4 border font-medium text-center">Meio de Pagamento</th>
                    <th className=" pb-4 border font-medium text-center">Telefone</th>
                    <th className=" pb-4 border font-medium text-center">Valor</th>
                    <th className=" pb-4 border font-medium text-center">Moeda</th>
                    <th className=" pb-4 border font-medium text-center">Data</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className=" font-light text-center">
                    <td className="border pb-4" >{recibo.userName}</td>
                    <td className="border pb-4" >{recibo.meioPagamento}</td>
                    <td className="border pb-4" >{recibo.numeroTelefone}</td>
                    <td className="border pb-4" >{recibo.valor}</td>
                    <td className="border pb-4" >MZN</td>
                    <td className="border pb-4" >{dataTransacao}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="w-full overflow-x-auto">
              <table className="w-full mt-2 mb-4 text-xs md:text-sm">
                <thead>
                  <tr className="border">
                    <th className="font-medium text-center border border-black pb-4">Referencia</th>
                    <th className="font-medium text-center border border-black pb-4">Descricao</th>
                    <th className="font-medium text-center border border-black pb-4">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border text-center">
                    <td className="border border-black pb-4">{recibo.idRecibo}</td>
                    <td className="border border-black pb-4">{recibo.descricao}</td>
                    <td className="border border-black pb-4">{recibo.valor}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="flex justify-between text-xs md:text-sm">
              <span>Documento Processado por Computador.</span>
              <span>Data e Hora {dataDownload}</span>
            </div>
          </div>
        </div>
        <div className="w-full max-w-4xl flex flex-col items-center mt-6">
          <div className="flex gap-4 w-full justify-center mt-4">
            <button
              onClick={() => {
                setDataDownload(gerarDataAtual());
                baixarRecibo();
                console.log(gerarDataAtual());
              }}
              type="button"
              className="bg-blue-500 text-white px-6 py-3 rounded-lg font-medium shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              <Download />
            </button>
            <button
              onClick={() => {
                window.print();
              }}
              className="bg-green-500 text-white px-6 py-3 rounded-lg font-medium shadow-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
            >
              <Printer />
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  );
}
